import Vue from 'vue'
import Element from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// import '../../element-variables.scss';
//ws的注释
import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import './reset.css'

Vue.use(Element, { size: 'small', zIndex: 3000 })

